// registration-v2.js — Entrypoint for the React registration page
// (Registration-V2). Mounts into `#js--registration-v2` at the existing
// `/authorization/registration/` URL — the homepage modal now links here
// instead of posting its own form.
import React from 'react';
import { createRoot } from 'react-dom/client';

import '../configs/bootstrap-ui.js';

import ErrorHandler from '../modules/error/error-handler.screen.js';
import RegistrationPage from '../modules/registration/RegistrationPage.js';

const rootEl = document.getElementById('js--registration-v2');
if (rootEl) {
	const root = createRoot(rootEl);
	root.render(
		<ErrorHandler>
			<RegistrationPage />
		</ErrorHandler>
	);
}
